// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: false,
  origin: 'https://servicios.radiotaxiupar.com/public/api',
  firebase: {
    apiKey: 'AIzaSyD5Vo1_xZdPlQ2H7B0nI1x7rSSSx8L19Uo',
    authDomain: 'clear-column-829.firebaseapp.com',
    databaseURL: 'https://clear-column-829.firebaseio.com',
    projectId: '"clear-column-829',
    storageBucket: 'clear-column-829.appspot.com',
    messagingSenderId: '846011681044'
  },

};
/* export const environment = {
  production: false,
  origin:"http://localhost/uparServe/public/api"
};*/



// WEBPACK FOOTER //
// ./src/environments/environment.ts